export default __webpack_public_path__ + "static/media/goshen78.731efd15.jpg";